import { ReactNode } from "react"

type BaseTableRowType = {
    onClick: () => void
    classProps?: string
    children: ReactNode
}

export default function BaseTableRow(props: BaseTableRowType) {

    return (
        <tr
            onClick={props.onClick}
            className={`z-0 border-b hover:bg-slate-50 border-gray-200 cursor-pointer text-sm h-14 ${props.classProps} -z-10`}>
            {props.children}
        </tr>
    )
}
